const MAX_CHARACTERS = 200;
const FONT_SIZES = ['32px', '28px', '25px'];

export const calculateAdjustedFontSize = (inputString: string) => {
  // Calculate the adjusted font size based on the length of the input string
  const adjustedSize = Math.ceil(
    (inputString.length / MAX_CHARACTERS) * FONT_SIZES.length,
  );
  // Ensure the adjusted size is within the valid range
  const finalSize = Math.min(Math.max(adjustedSize, 1), FONT_SIZES.length);
  return FONT_SIZES[finalSize - 1];
};
